import React, { useState } from "react";
import "./Contact.css";
import { api } from "./api";
import { EMAIL } from "./siteInfo";
import { FaEnvelope, FaMapMarkerAlt, FaPaperPlane, FaCheckCircle, FaExclamationCircle } from "react-icons/fa";

const EMPTY = { name: "", email: "", subject: "", message: "" };

const Contact = () => {
  const [formData, setFormData] = useState(EMPTY);
  const [status, setStatus] = useState("idle"); // idle | sending | success | error

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    if (status !== "idle" && status !== "sending") setStatus("idle");
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setStatus("sending");
    api("/api/contact", { method: "POST", body: formData })
      .then(() => {
        setStatus("success");
        setFormData(EMPTY);
      })
      .catch((error) => {
        console.error("Error:", error);
        setStatus("error");
      });
  };

  return (
    <section className="section contact" id="contact">
      <div className="container">
        <div className="card contact-panel">
          <div className="contact-glow" />

          <div className="contact-left">
            <span className="section-tag reveal">Contact</span>
            <h2 className="section-title reveal" style={{ "--d": "80ms" }}>
              Let's build something <em>great together</em>
            </h2>
            <p className="reveal" style={{ "--d": "140ms" }}>
              Have a project in mind or looking for a React developer to join
              your team? I'm always open to discussing new opportunities and
              collaborations.
            </p>

            <div className="contact-info reveal" style={{ "--d": "200ms" }}>
              <a className="info" href={`mailto:${EMAIL}`}>
                <span className="info-icon"><FaEnvelope /></span>
                <div>
                  <small>Email</small>
                  {EMAIL}
                </div>
              </a>
              <div className="info">
                <span className="info-icon"><FaMapMarkerAlt /></span>
                <div>
                  <small>Location</small>
                  Pune, Maharashtra
                </div>
              </div>
            </div>
          </div>

          <form className="contact-form reveal" style={{ "--d": "160ms" }} onSubmit={handleSubmit}>
            <div className="field-row">
              <label>
                <span>Name</span>
                <input type="text" name="name" placeholder="Your name" value={formData.name} onChange={handleChange} required autoComplete="name" />
              </label>
              <label>
                <span>Email</span>
                <input type="email" name="email" placeholder="you@example.com" value={formData.email} onChange={handleChange} required autoComplete="email" />
              </label>
            </div>
            <label>
              <span>Subject</span>
              <input type="text" name="subject" placeholder="What's this about?" value={formData.subject} onChange={handleChange} required />
            </label>
            <label>
              <span>Message</span>
              <textarea name="message" rows="5" placeholder="Tell me about your project..." value={formData.message} onChange={handleChange} required />
            </label>

            <button type="submit" className="btn btn-primary" disabled={status === "sending"}>
              {status === "sending" ? "Sending..." : <>Send message <FaPaperPlane /></>}
            </button>

            <div className="form-status" role="status" aria-live="polite">
              {status === "success" && (
                <p className="ok"><FaCheckCircle /> Message sent. I'll get back to you soon.</p>
              )}
              {status === "error" && (
                <p className="err"><FaExclamationCircle /> Couldn't send. Please try again or email me directly.</p>
              )}
            </div>
          </form>
        </div>
      </div>
    </section>
  );
};

export default Contact;
